// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partnership-container {
    max-width: 850px;
    margin: 0 auto;
    padding: 2rem 1.5rem;
    line-height: 1.6;
}

.partnership-image-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
}

.partnership-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}

.partnership-section {
    margin-bottom: 2rem;
}

    .partnership-section h2 {
        font-size: 1.4rem;
        margin-bottom: 0.5rem;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.25rem;
    }

.partnership-email {
    font-size: 1.2rem;
    margin: 1rem 0;
}

    .partnership-email a {
        color: #0066cc;
        text-decoration: none;
        font-weight: 500;
    }

        .partnership-email a:hover {
            text-decoration: underline;
        }

.partnership-note {
    font-size: 0.9rem;
    color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/PartnershipOpportunities.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;IAEI;QACI,iBAAiB;QACjB,qBAAqB;QACrB,6BAA6B;QAC7B,uBAAuB;IAC3B;;AAEJ;IACI,iBAAiB;IACjB,cAAc;AAClB;;IAEI;QACI,cAAc;QACd,qBAAqB;QACrB,gBAAgB;IACpB;;QAEI;YACI,0BAA0B;QAC9B;;AAER;IACI,iBAAiB;IACjB,WAAW;AACf","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.partnership-container {\r\n    max-width: 850px;\r\n    margin: 0 auto;\r\n    padding: 2rem 1.5rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.partnership-image-wrapper {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.partnership-image {\r\n    max-width: 100%;\r\n    height: auto;\r\n    border-radius: 8px;\r\n}\r\n\r\n.partnership-section {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n    .partnership-section h2 {\r\n        font-size: 1.4rem;\r\n        margin-bottom: 0.5rem;\r\n        border-bottom: 1px solid #ddd;\r\n        padding-bottom: 0.25rem;\r\n    }\r\n\r\n.partnership-email {\r\n    font-size: 1.2rem;\r\n    margin: 1rem 0;\r\n}\r\n\r\n    .partnership-email a {\r\n        color: #0066cc;\r\n        text-decoration: none;\r\n        font-weight: 500;\r\n    }\r\n\r\n        .partnership-email a:hover {\r\n            text-decoration: underline;\r\n        }\r\n\r\n.partnership-note {\r\n    font-size: 0.9rem;\r\n    color: #555;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
